/*
 * Who sees teacher bank details (account, IFSC, PAN/GSTIN): the payments team roles only, never
 * SUPER_USER or TEACHER_ONBOARDING on their own. Mirrors goserver canReviewPayoutDetails.
 */
import { hasAccess } from '../../../../util_functions';

export const BANK_DETAILS_ROLES = ['TEACHER_OPS_PAYMENT', 'TEACHER_PAYMENT_SUPER_USER'];

// Payment details (review queue + pop-up) and Bank payouts (eligible list, teacher-month dialog,
// deleted accounts) both show bank accounts.
export const BANK_DETAILS_TABS = ['payment-details', 'bank-payouts'];

export const BANK_DETAILS_FORBIDDEN_TEXT = "You don't have access to teacher bank details.";

// access_type is the comma-joined cms_user SET.
export const can_see_bank_details = (access_type) => hasAccess(access_type, ...BANK_DETAILS_ROLES);

// Full-details download: TEACHER_PAYMENT_SUPER_USER only (mirrors goserver canExportPayoutDetails).
export const FULL_DETAILS_EXPORT_ROLES = ['TEACHER_PAYMENT_SUPER_USER'];

export const can_export_full_details = (access_type) =>
  hasAccess(access_type, ...FULL_DETAILS_EXPORT_ROLES) && !hasAccess(access_type, 'NO_ACCESS');

// Month recalc_all: same role as the full export (mirrors goserver's recalc_all gate).
export const SUPER_USER_TABS = ['recalculate'];

export const RECALC_FORBIDDEN_TEXT =
  'Only a teacher payments super user may recalculate a whole month.';

// A tab-key predicate for tabs.js: bank tabs only for the payments roles, Recalculate only for the
// payments super user, every other tab as before.
export const tab_allowed_for = (access_type) => {
  const bank = can_see_bank_details(access_type);
  const super_user = can_export_full_details(access_type);
  return (tab_key) =>
    (bank || BANK_DETAILS_TABS.indexOf(tab_key) === -1) &&
    (super_user || SUPER_USER_TABS.indexOf(tab_key) === -1);
};

// The refusal a direct link to a tab this user may not see shows instead of the tab.
export const forbidden_tab_text = (tab_key) =>
  SUPER_USER_TABS.indexOf(tab_key) !== -1 ? RECALC_FORBIDDEN_TEXT : BANK_DETAILS_FORBIDDEN_TEXT;
